"use client";

import * as React from "react";

import { PAGE_SIZE_OPTIONS } from "@/constants/pagination";
import { getDefaultProjectOption, mapProjectSummaryToOption } from "@/lib/projectOptions";
import { useProject, useProjects } from "@/queries";
import type { EvidenceProjectOption } from "@/types";

interface UseSelectedProjectParams {
  account_id: string;
  role: string;
  initialProjectId?: string;
}

export function useSelectedProject({
  account_id,
  role,
  initialProjectId,
}: UseSelectedProjectParams) {
  const [userSelectedProject, setUserSelectedProject] =
    React.useState<EvidenceProjectOption | null>(null);

  const { data: projectsData } = useProjects({
    account_id,
    role,
    page: 1,
    page_size: PAGE_SIZE_OPTIONS[0],
  });

  const { data: initialProject } = useProject(
    { project_id: initialProjectId ?? "", account_id, role },
    !!initialProjectId
  );

  const selectedProject = React.useMemo(() => {
    if (userSelectedProject) return userSelectedProject;
    if (initialProjectId) {
      return initialProject ? mapProjectSummaryToOption(initialProject) : null;
    }
    return getDefaultProjectOption(projectsData?.items);
  }, [userSelectedProject, initialProjectId, initialProject, projectsData?.items]);

  return {
    userSelectedProject,
    setUserSelectedProject,
    selectedProject,
  };
}
